/**
 * Pure helpers for the campaign-media upload flow. `fileStemFromUrl` mirrors the server-side
 * `baseName`/`fileExt` in `apps/gfgf-api/src/utils/r2-helper.ts`: the crop names its output file
 * after its SOURCE image so the deterministic R2 key (`{name}-cropped.png`) stays stable across
 * re-crops. Keep the two in step.
 */

/** Last path segment of a URL, without query/hash or extension — the source image's base name. */
export function fileStemFromUrl(url: string): string {
  const path = url.split(/[?#]/)[0] ?? "";
  const seg = path.slice(path.lastIndexOf("/") + 1);
  let name = seg;
  try {
    name = decodeURIComponent(seg);
  } catch {
    // malformed encoding — keep the raw segment
  }
  const dot = name.lastIndexOf(".");
  return dot > 0 ? name.slice(0, dot) : name;
}
